import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Download18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M14.4697 7.46967L9.75 12.1894L9.75 1H8.25L8.25 12.1893L3.53039 7.46967L2.46973 8.53033L9.00006 15.0607L15.5304 8.53033L14.4697 7.46967Z'
      fill='currentColor'
    />
    <path d='M15 16.25H3V17.75H15V16.25Z' fill='currentColor' />
  </Svg>
);

Download18.displayName = 'Download18';
export default Download18;
